import { Badge } from '@arkestro/arkestro-design-system';
import { MailOutlined } from '@ant-design/icons';
import { ReactElement } from 'react';

interface Props {
  icon?: ReactElement;
  unreadCount?: number;
}

export const IconWithBadge = ({ icon, unreadCount } : Props) => {
  if (!unreadCount || unreadCount === 0) {
    return icon || <MailOutlined />;
  }

  return (
    <Badge
      className='badge-count'
      count={unreadCount}
      offset={[8, -4]}
      overflowCount={99}
      size='small'
    >
      {icon || <MailOutlined />}
    </Badge>
  );
};
